/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { Badge, Host } from '../recaptcha.types';

interface GenerateRecaptchaSrcParams {
    badge?: Exclude<Badge, 'hidden'>;
    hl?: string;
    host?: Host;
    isEnterprise?: boolean;
    render: string;
}

/**
 * Generates the script source URL for the Google reCAPTCHA.
 *
 * @param {GenerateRecaptchaSrcParams} params - The parameters for generating the script source URL.
 * @param {string} params.host - The host for the script source URL.
 * @param {string} params.render - The render parameter for the script source URL.
 * @param {string} params.hl - The hl parameter for the script source URL.
 * @param {string} params.badge - The badge parameter for the script source URL.
 * @return {string} The script source URL for the Google reCAPTCHA.
 */
export function generateRecaptchaScriptSrc({
    host = 'google.com',
    render,
    hl,
    badge,
}: GenerateRecaptchaSrcParams) {
    const queries = new URLSearchParams({
        ...(hl && { hl }),
        ...(badge && { badge }),
        render,
    });

    return `https://www.${host}/recaptcha/enterprise.js?${queries}`;
}
